import { cart, pubsub } from '@services';

class CartItems extends HTMLElement {
  unsubscribers = [];

  static {
    cart.sections.push('fetch-line-items');
    cart.sections.push('fetch-line-items-cart-drawer');
  }

  connectedCallback() {
    ['cart:add', 'cart:change'].forEach((event) =>
      this.unsubscribers.push(
        pubsub.subscribe(event, ({ sections }) => this.renderSections(sections))
      )
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Render the sections.
   * @param {Object} sections - The sections to render.
   */
  renderSections(sections) {
    const isInDrawer = this.closest('#cart-drawer') !== null;
    const sectionName = isInDrawer ? 'fetch-line-items-cart-drawer' : 'fetch-line-items';

    const html = new DOMParser().parseFromString(sections[sectionName], 'text/html');
    const target = html.querySelector('line-items');
    this.innerHTML = target.innerHTML;
  }
}

customElements.define('line-items', CartItems);
